import React from "react";
import { TOP_BANNER_MESSAGE_PAGE_DATA_MODEL } from "../../../constants";
import TopBannerAdminPanelEditOrDelete from "./TopBannerAdminPanelEditOrDelete";
import moment from "moment/moment";
import { App, CidmGroupName, DisplayText, Site, Title, UserId } from "./CustomCells";

const getActiveAndInactive = (item) =>{
    const now = new Date();
    const today = new Date(Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    ));
    const fromDate = new Date(item?.from);
    const toDate = new Date(item?.to);
    let isActive = today >= fromDate && today <= toDate; 
    return isActive;
}

export function metaData({ setApplication, setApplicationToDelete, openDialog }) {
  return {
    fields: {
      heading: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.heading.value,
        component: Title,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
       active: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.active.value,
        component: ({ item }) => getActiveAndInactive(item) ? "Yes" : "No",
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
        },
      }
      },
      site: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.site.value,
        component: Site,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
      app: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.app.value,
        component: App,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
      displayText:{
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.displayText.value,
        component: DisplayText,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
      cidmGroupName: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.cidmGroupName.value,
        component: CidmGroupName,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
      userId: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.userId.value,
        component: UserId,
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 400,
          whiteSpace: "nowrap",
          paddingRight: 15,
          paddingTop: 15,
          width:"60%"
        },
      }
      },
      from: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.from.value,
        component: ({ item }) => item.from? moment(item?.from).format("DD-MMM-YYYY") : "-",
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          fontWeight: 400,
          paddingRight: 15,
          paddingTop: 15
        },
      }
      },
      to: {
        text: TOP_BANNER_MESSAGE_PAGE_DATA_MODEL.to.value,
        component: ({ item }) => item.to? moment(item?.to).format("DD-MMM-YYYY") : "-",
        headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
          fontWeight: 400,
          paddingRight: 15,
          paddingTop: 15,
        },
      }
      },
      actions: {
        text: "",
        component: ({ item }) => (
          <TopBannerAdminPanelEditOrDelete
            item={item}
            setApplication={setApplication}
            setApplicationToDelete={setApplicationToDelete}
            openDialog={openDialog}
          />
        )
      }
    }
  };
}
